// AI-CONTEXT: Shared compact table visualisation for HouseVisits live-report
// widgets. The caller owns data fetching and aggregation; this component only
// renders report-friendly rows.

const defaultFormatter = new Intl.NumberFormat('nl-NL')

/**
 * @param {object} props
 * @param {Array<{id: string, label: string, count: number}>} props.rows
 * @param {string} props.labelHeader
 * @param {string} [props.countHeader='Aantal']
 * @param {string} [props.emptyMessage='Geen gegevens gevonden.']
 * @param {(value: number) => string} [props.formatCount]
 * @returns {JSX.Element}
 */
const HouseVisitsReportTableVisualization = ({
    rows,
    labelHeader,
    countHeader = 'Aantal',
    emptyMessage = 'Geen gegevens gevonden.',
    formatCount,
}) => {
    const visibleRows = Array.isArray(rows) ? rows : []
    const formatter = formatCount || ((value) => defaultFormatter.format(value))

    if (visibleRows.length === 0) {
        return (
            <div className="housevisits-report-table-empty">
                {emptyMessage}
            </div>
        )
    }

    return (
        <div className="housevisits-report-table-wrapper">
            <table className="housevisits-report-table">
                <thead>
                    <tr>
                        <th>{labelHeader}</th>
                        <th>{countHeader}</th>
                    </tr>
                </thead>
                <tbody>
                    {visibleRows.map((row) => (
                        <tr key={row.id}>
                            <td>{row.label}</td>
                            <td>{formatter(row.count)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default HouseVisitsReportTableVisualization
